import Link from '@/lib/link'
import { ContentPage, Prose, Section } from '@/components/content-page'

const channels = [
  {
    title: 'Community forum',
    body: 'Ask questions, compare provider settings, share solutions, and help someone get unstuck.',
  },
  {
    title: 'Public issue tracker',
    body: 'Follow reported bugs and feature requests, or open a focused issue in the source repository.',
  },
  {
    title: 'Share your setup',
    body: 'Post a screenshot, signature design, or workflow in Show and tell so others can learn from it.',
  },
]

export default function CommunityPage() {
  return (
    <ContentPage
      eyebrow="// community"
      title="Better email, shared experience"
      description="NewEmail is shaped by the people who use it. Bring a question, a sharp idea, or a helpful answer."
    >
      <Prose>
        <Section title="Ways to connect">
          <div className="grid gap-4">
            {channels.map((channel) => (
              <div key={channel.title} className="rounded-xl border border-border bg-card p-6">
                <h3 className="text-lg font-semibold text-foreground">{channel.title}</h3>
                <p className="mt-2 leading-relaxed text-muted-foreground">{channel.body}</p>
              </div>
            ))}
          </div>
        </Section>

        <Section title="A friendly place to learn">
          <p>
            Email setup can get technical, especially when a provider wants an app-specific
            password or a custom server setting. Ask the question anyway. Useful context and a
            patient answer make the forum better for the next person too.
          </p>
          <Link href="/forum" className="text-primary underline underline-offset-4">
            Visit the NewEmail forum
          </Link>
        </Section>

        <Section title="Help shape the next release">
          <p>
            Developers, designers, testers, and clear writers are all welcome. The source lives on
            GitHub, while the forum is the best place to discuss a change before building it.
          </p>
          <a
            href="https://github.com/ricktek954/newemail"
            target="_blank"
            rel="noreferrer"
            className="text-primary underline underline-offset-4"
          >
            Browse the source repository
          </a>
        </Section>
      </Prose>
    </ContentPage>
  )
}
